import React, { useEffect, useState, useRef } from "react";
import { AddRemove, Button, Checkbox, Dropdown, Input, toastMessage } from "../utils";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { buttonClasses } from "../utils/theme";
import { useAddPlantMutation, useUpdatePlantMutation } from "../../api/vmsSlice";
import { useCheckpointTypes, useOrgs, useStateOffices, useUserDetail, useUserPermissions, useProductCategories, useProducts, useSuppliers, } from "../../services/hooks";
import Geofence from "../utils/Geofence";
import { convertToCamelCase } from "../../services/functions";
import { usePlantContext } from "../../context/plantContext";
import { Tooltip } from "@mui/material";
import { ExpandMoreIcon, InfoIcon } from "../../services/icons";
import { valid_email, valid_mobile } from "../../services/validation";

const DEFAULT_CHEKPOINTS = [
	{ displayName: "Access", checkpointType: "access" },
	{ displayName: "Gate In", checkpointType: "gateIn" },
	{ displayName: "Bay", checkpointType: "bay" },
	{ displayName: "Gate Out", checkpointType: "gateOut" },
];

const defaultFilter = {
	pagesize: 100,
	page_no: 1,
};

const itemTypeOptions = [
	{ label: "Product", value: "product" }, 
	{ label: "Product Category", value: "productCategory" }, 
	{ label: "Supplier", value: "supplier" }
];
const defaultForm = {
	orgName: undefined,
	orgId: undefined,
	plantName: "",
	representativeEmail: "",
	representativeMobile: "",
	address: "",
	state: "",
	city: "",
	pincode: "",
	regionalOffice: "",
	factoryCoordinates: [],
	alertConfig : [
		{
			filterType : "",
			filterValue : "",
			threshold: 10,
			startCheckpointNumber: 1,
			notifyEmails: [],
			notifyMobiles: []
		}
	]
};
function fillUpdateData(data) {
	return {
		orgId: data.orgId,
		orgName: data.name,
		plantName: data.plantName,
		representativeEmail: data.representativeEmail,
		representativeMobile: data.representativeMobile,
		address: data.address,
		state: data.state,
		city: data.city,
		pincode: data.pincode,
		regionalOffice: data.regionalOffice,
		factoryCoordinates: data.factoryCoordinates || [],
		alertConfig : data.alertConfig && data.alertConfig.length > 0 ? data.alertConfig : [...defaultForm.alertConfig]
	};
}

const AddPlant = () => {
	const { getPlantDetails } = usePlantContext();
	const location = useLocation();
	const updateData = location.state?.updateData;
	const filterRef = useRef(defaultFilter);
	const { page_no = 1, pagesize = 20 } = filterRef.current;
	const { productCategories, message, getProdCats } = useProductCategories(filterRef.current);
	const { products, count: productCount, getProducts } = useProducts(filterRef.current);
	const { suppliers, count: supplierCount, getSuppliers } = useSuppliers(filterRef.current);
	const [formData, setFormData] = useState(updateData ? fillUpdateData(updateData) : defaultForm);
	const [errors, setErrors] = useState({});
	const [filterValueOption, setFilterValueOption] = useState([])
	const [allSelectedfilterValues, setAllSelectedfilterValues] = useState([])
	const [customizeCheckpoint, setCustomizeCheckpoint] = useState(false);
	const { checkpointTypeOptions } = useCheckpointTypes({ orgId: "all" });
	// console.log("updateData", updateData);
	const {states, statesOptions} = useStateOffices({})
	const { userPermissions, isFetched } = useUserPermissions();
	const isUpdate = location.pathname.includes("edit");
	const navigate = useNavigate();
	const { orgOptions } = useOrgs();
	const { userDetail } = useUserDetail();
	let orgId = userDetail?.orgId;
	const orgValue = orgOptions.find((_) => _.value == formData.orgId) || null;
	const stateValue= statesOptions.find((_)=>_.value == formData.state)
	if (userDetail?.userType === "superAdmin") {
		orgId = orgValue?.value;
	}
	const [handleSubmit] = useAddPlantMutation();
	const [handleUpdate] = useUpdatePlantMutation();

	useEffect(() => {
		if (isUpdate && !updateData) {
			navigate("/plants");
		}
	}, []);
	useEffect(() => {
		if (isUpdate && !updateData) {
			return;
		}
		const source = updateData?.alertConfig;
		if (!source?.length) return;
		// Build all options in ONE pass → ONE update
		const updatedOptions = source.map(el => getOptionsByType(el.filterType));
		// console.log('updatedOption1',source, updatedOptions)
		setFilterValueOption(updatedOptions);
		const filterValues = formData?.alertConfig.map((el) => el.filterValue);
		setAllSelectedfilterValues(filterValues)
	}, [updateData, suppliers, products, productCategories]);

	const getOptionsByType = (type) => {
		switch (type) {
			case "supplier":
			return suppliers?.filter((el => el.plantId === updateData._id))?.map(ele => ({
				label: ele.supplierName,
				value: ele._id,
			})) || [];

			case "product":
			return products?.filter((el => el.plantId === updateData._id))?.map(ele => ({
				label: ele.productName,
				value: ele._id,
			})) || [];

			case "productCategory":
			return productCategories?.filter((el => el.plantId === updateData._id))?.map(ele => ({
				label: ele.productCategory,
				value: ele._id,
			})) || [];

			default:
			return [];
		}
	};

	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};
	const onDropdownChange = (option, name) => {
		setFormData({ ...formData, [name]: option?.value });
	};
	const handleClose = () => {
		setFormData(defaultForm);
		navigate("/plants");
	};
	const handleAlertConfigChange = (value, name, i) => {
		// 
		if(i <= 2){
			if(name === 'filterType'){
				const source = formData?.alertConfig.map((el) => el.filterType);
				source[i] = value
				// console.log('source', source, i, value)
				const updatedOptions = source.map((el, i )=> getOptionsByType(el));
				console.log('updatedOption2', updatedOptions)
				setFilterValueOption(updatedOptions);
			}
			if(name === 'filterValue'){
				let source = formData?.alertConfig.map((el) => el.filterValue);
				if(value === null){
					let source1 = formData?.alertConfig[i].filterValue;
					// console.log('existed', source1)
					let arr = allSelectedfilterValues.filter((el) => el !==  source1);
					// console.log('existed-new', arr)
					setAllSelectedfilterValues(arr)
				}else{
					if(!source.includes(value.value)){
					   source.push(value.value)
				    } 
					setAllSelectedfilterValues(source)
				}
				
				
			}
			setFormData(prev => ({
				...prev,
				alertConfig: prev.alertConfig.map((config, index) =>
					index === i ? { ...config, [name]:  Array.isArray(value) ? value.map((_)=> _.value) : (value?.value ? value.value  : value) } : config
				),
			}));
		}
	};
	const addAlertConfig = () => {
		setFormData((old) => ({
			...old,
			alertConfig: [
				...old.alertConfig,
				...defaultForm.alertConfig
			],
		}));
	};
	const removeAlertConfig = (index) => {
		setFormData((old) => ({
			...old,
			alertConfig: old.alertConfig.filter((_, i) => i !== index),
		}));
	};
	function validateForm(formData) {
		let errors = {};
		let success = true;

		// Validate orgName
		if (userDetail?.userType == "superAdmin" && !formData?.orgId) {
			errors.orgId = "Organization name is required";
			success = false;
		}
		// Validate plantName
		if (!formData.plantName.trim()) {
			errors.plantName = "Warehouse name is required";
			success = false;
		}

		// Validate representativeEmail
		// if (!formData.representativeEmail.trim()) {
		// 	errors.representativeEmail = "Email is required";
		// 	success = false;
		// } else if (!/^\S+@\S+\.\S+$/.test(formData.representativeEmail)) {
		// 	errors.representativeEmail = "Invalid email address";
		// 	success = false;
		// }

		// // Validate representativeMobile
		// if (!formData.representativeMobile.trim()) {
		// 	errors.representativeMobile = "Mobile number is required";
		// 	success = false;
		// } else if (formData.representativeMobile.trim().length !== 10) {
		// 	errors.representativeMobile = "Mobile number must be 10 digits";
		// 	success = false;
		// }

		// // Validate address
		// if (!formData.address) {
		// 	errors.address = "Address is required";
		// 	success = false;
		// }

		// // Validate state
		// if (!formData.state) {
		// 	errors.state = "State is required";
		// 	success = false;
		// }

		// // Validate city
		// if (!formData?.city) {
		// 	errors.city = "City is required";
		// 	success = false;
		// }

		// // Validate pincode
		// if (!formData?.pincode) {
		// 	errors.pincode = "Pincode is required";
		// 	success = false;
		// } else if (!/^\d{6}$/.test(formData.pincode.trim())) {
		// 	errors.pincode = "Invalid pincode";
		// 	success = false;
		// }
		return { errors, success };
	}
	const handleGeofenceCoordinatesChange = (coordinates) => {
		setFormData((prevFormData) => ({
			...prevFormData,
			factoryCoordinates: coordinates, // Update factoryCoordinates in formData
		}));
	};
	const handleFormSubmit = async () => {
		const { success, errors } = validateForm(formData);
		if (success) {
			setErrors({});
			let payload = { ...formData };
			if (payload.checkpoints) {
				payload.checkpoints = payload.checkpoints
					.filter((_) => _.displayName)
					.map((_) => {
						return { ..._, displayName: _.displayName.trim(), checkpointStatus: convertToCamelCase(_.displayName.trim()) };
					});
			}
			if (userDetail?.userType === "superAdmin") {
				payload.orgName = orgValue?.label;
			}
			// console.log("payload", payload);
			let updatePayload = {
				id: updateData?._id,
				updateData: {
					...formData,
				},
			};
			// console.log('payload', payload)
			const {
				data: { error, message },
			} = isUpdate ? await handleUpdate(updatePayload) : await handleSubmit(payload);
			if (error) {
				toastMessage(false, message);
			} else {
				toastMessage(true, message);
				handleClose();
				if (userDetail?.userType != "superAdmin") {
					getPlantDetails({ orgId: userDetail?.orgId });
				}
				navigate("/plants");
			}
		} else {
			setErrors(errors);
			return;
		}
	};

	// if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions?.getPlants?.value) return <Navigate to="/not-authorized" replace />;
	return (
    <div className="contentpanel">
      <div className="cust-row flex-algn-cent" style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="cust-col-5">
          <h1 className="title">{isUpdate ? "Update Warehouse" : "Add Warehouse"}</h1>
        </div>
        <div className="cust-col-5 flex-jc-end">
          <Link to="/plants" className=" ">
            <Button className="" text="Go Back" style={buttonClasses.lynkitOrangeEmpty} />
          </Link>
        </div>
      </div>
      <hr className="bgg" />

      <form className="">
        <div className="form-inputs mt-2">
          {userDetail?.userType == "superAdmin" ? (
            <Dropdown id="orgId" name="orgId" label="Organization Name" onChange={onDropdownChange} options={orgOptions} value={orgValue} error={errors?.orgId} required />
          ) : null}
          <Input error={errors?.plantName} label="Warehouse Name" placeholder="Enter Warehouse Name" name="plantName" value={formData.plantName} onChange={handleInput} required={true} />
          <Input
            // error={errors?.representativeMobile}
            label="Mobile"
            placeholder="Enter Mobile"
            name="representativeMobile"
            value={formData.representativeMobile}
            onChange={handleInput}
            // required={true}
          />
          <Input
            // error={errors?.representativeEmail}
            type="email"
            label="Email"
            placeholder="Enter Email"
            name="representativeEmail"
            value={formData.representativeEmail}
            onChange={handleInput}
            // required={true}
          />
          <Input label="Address" placeholder="Enter Address" name="address" value={formData.address} onChange={handleInput} />
          <Dropdown id="state" label="State" placeholder="Select State" name="state" options={statesOptions} value={stateValue} onChange={onDropdownChange} />
          <Input label="City" placeholder="Enter City" name="city" value={formData.city} onChange={handleInput} />
          <Input label="Regional Office" placeholder="Enter Regional Office" name="regionalOffice" value={formData.regionalOffice} onChange={handleInput} />
          <Input label="Pincode" placeholder="Enter Pincode" name="pincode" value={formData.pincode} onChange={handleInput} />
          {!updateData ? (
            <Checkbox
              name="customizeCheckpoint"
              checked={customizeCheckpoint}
              onChange={(e) => {
                setCustomizeCheckpoint(e.target.checked);
                if (e.target.checked) {
                  setFormData((o) => ({ ...o, checkpoints: DEFAULT_CHEKPOINTS }));
                } else {
                  setFormData((o) => {
                    let n = { ...o };
                    delete n.checkpoints;
                    return n;
                  });
                }
              }}
              label="Customize Checkpoints"
            />
          ) : null}
        </div>
        {!updateData && customizeCheckpoint ? (
          <div className="theme-container">
            <h6>Checkpoints</h6>
            <div style={{ display: "flex", gap: "0.5rem", flexDirection: "column", marginTop: "0.75rem" }}>
              {formData.checkpoints.map(({ displayName, checkpointType }, i) => {
                return (
                  <div key={i} style={{ display: "grid", gap: "1rem", gridTemplateColumns: "30% 30% 10%" }}>
                    <Input
                      name="displayName"
                      label="Display Name"
                      value={displayName}
                      onChange={(e) => {
                        setFormData((o) => ({
                          ...o,
                          checkpoints: o.checkpoints.map((_, j) => {
                            if (i == j) {
                              return { ..._, [e.target.name]: e.target.value };
                            }
                            return _;
                          }),
                        }));
                      }}
                    />
                    <Dropdown
                      name="checkpointType"
                      label="Checkpoint Type"
                      value={checkpointTypeOptions.find((_) => _.value == checkpointType) || null}
                      onChange={(opt, name) => {
                        setFormData((o) => ({
                          ...o,
                          checkpoints: o.checkpoints.map((_, j) => {
                            if (i == j) {
                              return { ..._, [name]: opt?.value || "" };
                            }
                            return _;
                          }),
                        }));
                      }}
                      options={checkpointTypeOptions}
                    />
                    <AddRemove
                      list={formData.checkpoints}
                      filterMethod={(_) => _.displayName == "" && _.checkpointType == ""}
                      onAdd={() => {
                        setFormData((o) => ({ ...o, checkpoints: [...o.checkpoints, { displayName: "", checkpointType: "" }] }));
                      }}
                      onRemove={(i) => {
                        setFormData((o) => ({ ...o, checkpoints: o.checkpoints.filter((_, j) => j != i) }));
                      }}
                      index={i}
                      outerIndex={i}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
        <div className="theme-container">
          <h6>Alert Configuration</h6>
          {formData.alertConfig.map((config, index) => (
            <div style={{ display: "flex", gap: "0.5rem", width: "100%", marginBottom : "10px" }}>
              <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }} className="p-3 border boder-rad-10p ">
				{updateData && <><div style={{ display: "flex", alignItems: "center", minWidth: "220px" }}>
					<Dropdown
						id="filterType"
						name="filterType"
						value={config.filterType ? itemTypeOptions.find((_) => _.value == config.filterType) : null}
						options={itemTypeOptions}
						label="Item Type"
						onChange={(option, name) => handleAlertConfigChange(option?.value ? option.value : null , name, index)}
						// error={errors?.type}
					/>
				</div>
				<div style={{ display: "flex", alignItems: "center", minWidth: "220px" }}>
					{/* <p>{config.filterValue}</p> */}
					<Dropdown
						id="filterValue"
						name="filterValue"
						value={config.filterValue ? filterValueOption[index]?.find((ele) => ele.value === config.filterValue) : null}
						options={filterValueOption[index]?.filter((el)=>  !allSelectedfilterValues.includes(el.value)) || []}
						label="Item"
						onChange={(option, name) => handleAlertConfigChange(option, name, index)}
						// error={errors?.item}
					/>
				</div></>}
                <Input
                  type="number"
                  id={`Alert Threshold`}
                  name="threshold"
                  value={config.threshold || 0}
                  label="Alert Threshold (sec)"
                  onChange={(e) => handleAlertConfigChange(e.target.value, e.target.name, index)}
                  required={true}
                  // error={error.BoomOpenAlertThreshold}
                  min="0"
                />
                <Input
                  type="number"
                  id={`startCheckpointNumber`}
                  name="startCheckpointNumber"
                  value={config.startCheckpointNumber || 1}
                  label="Start Checkpoint Number"
                  onChange={(e) => handleAlertConfigChange(e.target.value, e.target.name, index)}
                //   required={true}
                  min="1"
                />
                <div style={{ display: "flex", alignItems: "center", minWidth: "280px" }}>
                  <Dropdown
                    id={`notifyEmails`}
                    name="notifyEmails"
                    label="Notify Emails"
                    onChange={(option, name) => handleAlertConfigChange(option, name, index)}
                    options={config.notifyEmails?.length > 0 ? config.notifyEmails.map((el) => ({ label: el, value: el })) : []}
                    value={config.notifyEmails?.length > 0 ? config.notifyEmails.map((el) => ({ label: el, value: el })) : []}
                    enableCustomValue={true}
                    validateValue={(value) => valid_email(value)}
                    // error={error.BoomOpenNotifyEmails}
                    multiple={true}
                    required
                  />
                  <Tooltip style={{ marginLeft: "1px" }} title="Type email and press Enter to add to list. Multiple emails supported.">
                    <InfoIcon sx={{ fill: "#ff7200", marginLeft: "-15px", marginRight: "15px" }} />
                  </Tooltip>
                </div>
                <div style={{ display: "flex", alignItems: "center", minWidth: "280px" }}>
                  <Dropdown
                    id={`notifyMobiles`}
                    name="notifyMobiles"
                    label="Notify Mobiles"
                    onChange={(option, name) => handleAlertConfigChange(option, name, index)}
                    options={config.notifyMobiles?.length > 0 ? config.notifyMobiles.map((el) => ({ label: el, value: el })) : []}
                    value={config.notifyMobiles?.length > 0 ? config.notifyMobiles.map((el) => ({ label: el, value: el })) : []}
                    enableCustomValue={true}
                    validateValue={(value) => valid_mobile(value)}
                    // error={error.BoomOpenNotifyMobiles}
                    multiple={true}
                    // required
                  />
                  <Tooltip style={{ marginLeft: "1px" }} title="Type mobile and press Enter to add to list. Multiple mobile number supported.">
                    <InfoIcon sx={{ fill: "#ff7200", marginLeft: "-15px", marginRight: "15px" }} />
                  </Tooltip>
                </div>
                <AddRemove list={formData.alertConfig} filterMethod={(item) => !item.threshold} onAdd={addAlertConfig} onRemove={removeAlertConfig} index={index} outerIndex={index} maxAddLimit={3} />
              </div>
            </div>
          ))}
        </div>
        <div className="theme-container">
          <h6>Add Geofence</h6>
          <Geofence onCoordinatesChange={handleGeofenceCoordinatesChange} factoryCoordinates={formData?.factoryCoordinates} />
        </div>
        <div className="" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1rem" }}>
          <Button text={isUpdate ? "Update" : "Submit"} style={{ ...buttonClasses.lynkitOrangeFill, width: "15%" }} onClick={handleFormSubmit} />
        </div>
      </form>
    </div>
  );
};

export default AddPlant;
